<div>
  <!-- Print / Close Buttons -->
  <div style="margin-left: 70%; margin-bottom: 2%">
    <button printSectionId="print-section1" mat-raised-button color="primary" ngxPrint [useExistingCss]="true"
      class="noPrint">
      Print
    </button>
    <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
  </div>

  <!-- Print Section -->
  <div id="print-section1">
    <div class="container" *ngFor="let invoice of invoiceList; let idx = index">

      <!-- Header -->
      <div class="row">
        <div class="col-9 topheader">
          <span class="fontBold">हिंदुस्थान प्रकाशन संस्था</span>
          <span><span class="heading1">प्रशासकीय कार्यालय</span> - </span>
          <span>
            116-119, पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग, वडाळा मुंबई - 400031
          </span>
          <span>दूरध्वनी: ९९६७५७०५३१, Email: vivekbookdept&#64;gmail.com</span>
        </div>
        <div class="col-3 flex">
         <img src="../../../assets/img/brand/book.png"style="width:60%;" alt="Logo" class="logo-img" />
        </div>
      </div>

      <!-- GST & PAN -->
      <div class="row">
        <div class="col-6">
          <b>GSTIN/Unique Id :</b> 27AAATH0433Q1ZI
        </div>
        <div class="col-6">
          <b>PAN No. :</b> AAATH0433Q
        </div>
      </div>

      <!-- Invoice No & Date -->
      <div class="row">
        <div class="col-6">
          <b>Invoice No. :</b> {{ invoice.invoice_header.invoice_no }}
        </div>
        <div class="col-6">
          <b>Date :</b> {{ invoice.invoice_header.invoice_date | date: 'dd-MM-yyyy' }}
        </div>
      </div>

      <!-- Receiver & Cosignee -->
      <div class="row">
        <div class="col-6">
          <h3><b>Details of Receiver :</b></h3>
          <span class="receiver"><b>Name :</b> <strong>{{ invoice.invoice_header.receiver_name }}</strong></span>
          <span class="receiver"><b>Address :</b>
            {{ invoice.invoice_header.receiver_address }}
          </span>
          <span class="receiver"><b>Phone :</b> {{ invoice.invoice_header.mobile }}</span>
          <span class="receiver"><b>GSTIN :</b> {{ invoice.invoice_header.gst || 'NA' }}</span>
        </div>
        <div class="col-6">
          <h3><b>Details of Cosignee :</b></h3>
          <span class="receiver">Name :</span>
          <span class="receiver">Address :</span>
          <span class="receiver">Phone :</span>
          <span class="receiver">GSTIN :</span>
        </div>
      </div>

      <!-- Table Header -->
      <div class="row">
        <div class="col-1 tableDescheader">S.No</div>
        <div class="col-3 tableDescheader">Book Name</div>
        <div class="col-1 tableDescheader">HSN Code</div>
        <div class="col-1 tableDescheader">Book Price</div>
        <div class="col-1 tableDescheader">Sale Price</div>
        <div class="col-1 tableDescheader">Discount Amount</div>
        <div class="col-1 tableDescheader">Net Amount</div>
        <div class="col-1 tableDescheader">Book Copies</div>
        <div class="col-2 tableDescheader">Total Taxable Value</div>
      </div>

      <!-- Table Rows -->
      <div class="row" *ngFor="let item of invoice.invoice_items; let i = index">
        <div class="col-1 tableDesc">{{ i + 1 }}</div>
        <div class="col-3 tableDesc" style="text-align: left;font-size: 18px;">{{ item.book_name }}</div>
        <div class="col-1 tableDesc" style="text-align: right;font-size: 18px;">4902</div>
        <div class="col-1 tableDesc" style="text-align: right;font-size: 18px;">{{ item.rate }}</div>
        <div class="col-1 tableDesc" style="text-align: right;font-size: 18px;">{{ item.sale_rate }}</div>
        <div class="col-1 tableDesc" style="text-align: right;font-size: 18px;">{{ item.discountamt | number:'1.2-2' }}</div>
        <div class="col-1 tableDesc" style="text-align: right;font-size: 18px;">{{ (item.totalafterdiscount ?? 0) | number:'1.2-2' }}</div>
        <div class="col-1 tableDesc" style="text-align: right;font-size: 18px;">{{ item.copies }}</div>
        <div class="col-2 tableDesc" style="text-align: right;font-size: 18px;">{{ item.total|| '1.2.2' }}</div>
      </div>

      <!-- Invoice Total in Words + GST -->
      <div class="row noborderRow">

        <div class="col-8 heading1" style="border-bottom: 2px solid black;">
          <strong>Invoice Total in Words:</strong> {{ invoice.amtinwords }}
        </div>

        <div class="col-4">
          <table style="width: 100%; border-collapse: collapse; text-align: center;">
            <tr>
              <th>SGST</th>
              <th>CGST</th>
              <th>IGST</th>
              <th>Total GST</th>
            </tr>
            <tr>
              <td>{{ invoice.invoice_header.SGST_percent }}%</td>
              <td>{{ invoice.invoice_header.CGST_percent }}%</td>
              <td>{{ invoice.invoice_header.IGST_percent }}%</td>
              <td><strong>{{ invoice.invoice_header.pecent }}%</strong></td>
            </tr>
            <tr>
              <td>{{ invoice.invoice_header.SGST }}</td>
              <td>{{ invoice.invoice_header.CGST }}</td>
              <td>{{ invoice.invoice_header?.IGST || '1.2.2' }}</td>
              <td><strong>{{ invoice.invoice_header.gst|| '1.2.2' }}</strong></td>
            </tr>
          </table>
        </div>
      </div>

      <!-- Bank & Total -->
      <div class="row">
        <div class="col-8" style="display: flex; justify-content: space-between;">
          <div>
            <div><b>Bank Details:</b></div>
            <div>A/C Name - HINDUSTAN PRAKASHAN SANSTHA</div>
            <div>A/C No. - 20109800154</div>
            <div>IFSC No. - MAHB0000318</div>
            <div>Bank Name - Bank of Maharashtra</div>
            <div>Branch - Prabhadevi, Mumbai - 400025</div>
          </div>
          <div>
            <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code" class="qr-code" />
          </div>
        </div>
        <!-- <div class="col-4" style="display: flex; flex-direction: column; border-bottom: 1px solid black; padding: 1px;">
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Total :</span><span><strong>{{ invoice.total_total + (+invoice.gstAmount || 0) }}</strong></span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Shipping Charges :</span><span>{{ invoice.shipping_charges_total }}</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Round Off :</span><span>0</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Invoice Total :</span><span><strong>{{ invoice.totals + (+invoice.gstAmount || 0) }}</strong></span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Previous Deposit :</span><span>0</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Previous Dues :</span><span>0</span></div>
          <div class="spacebet" style="font-weight: 500; padding: 6px 8px;"><span>Total Dues :</span><span>{{ invoice.totals + (+invoice.gstAmount || 0) }}</span></div>
        </div> -->
        <div class="col-4" style="display: flex; flex-direction: column; border-bottom: 1px solid black; padding: 1px;">

          <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
            <span>Total :</span>
            <span style="text-align: right; min-width: 100px;"><strong>{{ invoice.total_total + (+invoice.gstAmount ||
                0) }}</strong></span>
          </div>

          <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
            <span>Shipping Charges :</span>
            <span style="text-align: right; min-width: 100px;">{{ invoice.shipping_charges_total }}</span>
          </div>

          <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
            <span>Round Off :</span>
            <span style="text-align: right; min-width: 100px;">0</span>
          </div>

          <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
            <span>Invoice Total :</span>
            <span style="text-align: right; min-width: 100px;"><strong>{{ invoice.totals + (+invoice.gstAmount || 0)
                }}</strong></span>
          </div>

          <div style="display: flex; justify-content: space-between; border-bottom: 2px solid black; padding: 6px 8px;">
            <span>Previous Dues :</span>
            <span style="text-align: right; min-width: 100px;">{{ invoice.invoice_header.opening_bal }}</span>
          </div>

          <div style="display: flex; justify-content: space-between; font-weight: 500; padding: 6px 8px;">
            <span>Total Dues :</span>
            <span style="text-align: right; min-width: 100px; font-weight: bold;">{{
              (+invoice.totals || 0)
              + (+invoice.gstAmount || 0)
              + (+invoice.invoice_header?.opening_bal || 0)
              }}
            </span>
          </div>
        </div>
      </div>

      <!-- Terms & Signature -->
      <div class="row">
        <div class="col-8 flexbox" style="padding: 15px;">
          <h2>Terms:</h2>
          <span>1) Complaints of any nature must be communicated in writing within 10 Days from the date of
            delivery.</span>
          <span>2) A/C payee cheques to be drawn in favor of :-</span>
          <span>हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग</span>
        </div>
        <div class="col-4 flexadd" style="padding: 15px;">
          <span style="font-size: 1.2rem; font-weight: 700;">हिंदुस्थान प्रकाशन संस्था</span>
          <div style="height: 80px;"></div>
          <div style="text-align: center;"><span>Authorised Signatory</span></div>
        </div>
      </div>
    </div>
  </div>
</div>